import { Carousel } from "react-responsive-carousel";
import { DiscountFlag } from "../../../components/DiscountFlag";
import CopyToClipboard from "react-copy-to-clipboard";
import IconesNovos from "../../../components/NewIcones/IconesNovos";
import NoImg from "../../../assets/images/no-image.png";
import { useState } from "react";
import { useToast } from "../../../hooks/useToast";
import { useLocation } from "react-router-dom";
import "../index.css";

type VariationImageType = {
  image: string;
  sku: string;
  order: number;
};

type PropsProductImage = {
  price: number;
  promotionalPrice: number;
  showFlag: boolean;
  config: any;
  variationImagesNow: VariationImageType[];
  goToLastImagem: number;
  setModalImage: (value: boolean) => void;
  setUrlImageOpen: (value: string) => void;
  animate: boolean;
  handleAnimation: (type: string) => void;

  // Novas props para a funcionalidade de favorito
  favoriteProduct?: boolean;
  animateHeart?: boolean;
  saveFavorite?: () => void;
  isLoggedIn?: boolean;
};

export function ProductImage({
  price,
  promotionalPrice,
  showFlag,
  config,
  variationImagesNow,
  goToLastImagem,
  setModalImage,
  setUrlImageOpen,
  animate,
  handleAnimation,
  favoriteProduct,
  animateHeart,
  saveFavorite,
  isLoggedIn,
}: PropsProductImage) {
  const { openToast } = useToast();
  const location = useLocation();
  const [loadingImage, setLoadingImage] = useState(true);

  return (
    <div className="product-image relative">
      {promotionalPrice !== 0 && promotionalPrice !== price && showFlag ? (
        <DiscountFlag
          type={
            config?.content.flagDiscount
              ? config?.content.flagDiscount
              : "trigonal"
          }
          color={
            config?.webappcolor.flagDiscountColor
              ? config?.webappcolor.flagDiscountColor
              : "#000"
          }
          value={parseInt(
            (((price - promotionalPrice) / price) * 100).toFixed(2),
          )}
          isDetailProductPage
          isList={false}
        />
      ) : (
        <></>
      )}
      <div id="list-images">
        <Carousel
          key={`${variationImagesNow
            .map((img) => img.image)
            .join(",")}-${Date.now()}`}
          showThumbs={false}
          showStatus={false}
          showArrows={true}
          selectedItem={goToLastImagem ?? 0} // Sempre começar do primeiro item quando mudar
          swipeable={true}
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={50}
        >
          {variationImagesNow.length === 0
            ? [
                <div
                  className={`w-full flex justify-center product-image-carousel`}
                  style={
                    loadingImage
                      ? {
                          visibility: "hidden",
                          width: 0,
                          height: 0,
                        }
                      : {}
                  }
                  onLoad={() => {
                    setLoadingImage(false);
                  }}
                  key={"no-image"}
                  onClick={() => {
                    setModalImage(true);
                    setUrlImageOpen(NoImg);
                  }}
                >
                  <img
                    src={NoImg}
                    className={`rounded-medium object-contain`}
                    alt="Sem imagem"
                  />
                </div>,
              ]
            : variationImagesNow.map((variationImg) => (
                <div
                  className={`w-full flex justify-center product-image-carousel`}
                  style={
                    loadingImage
                      ? {
                          visibility: "hidden",
                          width: 0,
                          height: 0,
                        }
                      : {}
                  }
                  onLoad={() => {
                    setLoadingImage(false);
                  }}
                  key={variationImg.image}
                  onClick={() => {
                    setModalImage(true);
                    setUrlImageOpen(variationImg.image || NoImg);
                  }}
                >
                  <img
                    src={variationImg.image || NoImg}
                    className={`rounded-medium object-contain`}
                    alt={variationImg.image || "Sem imagem"}
                  />
                </div>
              ))}
        </Carousel>
      </div>

      {/* Ícone de Favorito (Acima do share, apenas para logados) */}
      {isLoggedIn && (
        <div className="favorite-float-btn">
          <button
            className={
              animateHeart ? "animate__animated animate__heartBeat" : ""
            }
            onClick={saveFavorite}
          >
            {favoriteProduct ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="#E11D48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#222"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
              </svg>
            )}
          </button>
        </div>
      )}

      {/* Ícone de Compartilhar */}
      <div className="share-float-btn">
        <CopyToClipboard
          text={window.location.origin + location.pathname}
          onCopy={() => {
            handleAnimation("share");
            openToast("success", "Link copiado com sucesso!");
          }}
        >
          <button
            className={animate ? "animate__animated animate__heartBeat" : ""}
          >
            <IconesNovos
              cor={"#222"}
              active={true}
              type={"plane"}
              action={() => {}}
            />
          </button>
        </CopyToClipboard>
      </div>
    </div>
  );
}
